const { CrudModel } = require('./crud');

export class SpecialtyModel extends CrudModel {
	constructor() {
		super('admin/specialty', []);
	}
}

export default new SpecialtyModel();
